export const readerExperienceFlags = {
  readerTrending: import.meta.env?.VITE_FEATURE_READER_TRENDING !== 'false',
  publicCounts: import.meta.env?.VITE_FEATURE_PUBLIC_COUNTS === 'true',
  publicEngagementCounts: import.meta.env?.VITE_FEATURE_PUBLIC_COUNTS === 'true',
  newStoryActionBar: import.meta.env?.VITE_FEATURE_STORY_ACTION_BAR !== 'false',
  newMobileNavigation: import.meta.env?.VITE_FEATURE_MOBILE_NAVIGATION !== 'false',
  homepageIntelligenceHero: import.meta.env?.VITE_FEATURE_HOMEPAGE_INTELLIGENCE !== 'false',
  wrongCategoryReporting: import.meta.env?.VITE_FEATURE_WRONG_CATEGORY_REPORTING !== 'false',
  askOmikinaEntry: import.meta.env?.VITE_FEATURE_ASK_ENTRY !== 'false',
  discussions: import.meta.env?.VITE_FEATURE_DISCUSSIONS !== 'false',
  askOmikina: import.meta.env?.VITE_FEATURE_ASK_OMIKINA === 'true',
  signalPages: import.meta.env?.VITE_FEATURE_SIGNAL_PAGES !== 'false',
  compareCoverage: import.meta.env?.VITE_FEATURE_COMPARE_COVERAGE !== 'false',
  synchronizedDesk: import.meta.env?.VITE_FEATURE_SYNCED_DESK === 'true',
} as const

export const engagementDisplay = {
  minimumReaderImpressions: 25,
  minimumUniqueEngagedReaders: 5,
  minimumPublicPulseCount: 5,
  minimumPublicDiscussionCount: 3,
} as const

export function publicEngagementCount(count: number, kind: 'pulse' | 'discussion', enabled = readerExperienceFlags.publicEngagementCounts): number | undefined {
  const threshold = kind === 'pulse' ? engagementDisplay.minimumPublicPulseCount : engagementDisplay.minimumPublicDiscussionCount
  return enabled && Number.isFinite(count) && count >= threshold ? Math.floor(count) : undefined
}
